import env from "@/env"
import fallbackConfig from "@/assets/fallback/fallback.config.json"

export type ImageSpaceName = "Accounts" | "Axes" | "Projects" | "Template"

interface FallbackEntry {
  image: string
  items: string[]
}

const fallbackMap: Record<string, string> = {}
;(fallbackConfig as FallbackEntry[]).forEach((entry) => {
  entry.items.forEach((itemId) => {
    fallbackMap[itemId] = entry.image
  })
})

function getSpacePath(spaceName: ImageSpaceName) {
  return spaceName === "Template" ? "Templates" : spaceName
}

export function getImageUrl(spaceName: ImageSpaceName, itemId: string, cacheBust?: string | number): string {
  if (fallbackMap[itemId]) {
    return require(`@/assets/fallback/${fallbackMap[itemId]}.png`)
  }

  return env.REACT_APP_URL_SPACE.concat(
    "/",
    getSpacePath(spaceName),
    "/",
    itemId,
    ".png?",
    String(cacheBust ?? Date.now())
  )
}

export function getAxisImageUrl(imageId: string, isDefaultImage: boolean): string {
  if (fallbackMap[imageId]) {
    return require(`@/assets/fallback/${fallbackMap[imageId]}.png`)
  }

  const path = isDefaultImage ? "/_default/" : "/Axes/"
  return env.REACT_APP_URL_SPACE.concat(path, imageId, ".png?", Date.now().toString())
}

export function getProjectImageUrl(projectResponse: any): string {
  if (projectResponse.image && projectResponse.customImage) {
    return getImageUrl("Projects", projectResponse.id)
  }

  if (projectResponse.Template?.image) {
    return getImageUrl("Template", projectResponse.Template.image)
  }

  return require("@/assets/add.png")
}
